import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CategoriesIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1.2A3 3 0 0 1 20 9v1.2a3 3 0 0 1 2 2.8v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-6a3 3 0 0 1 2-2.8V9a3 3 0 0 1 2-2.8V5Zm2 1h8V5c0-.6-.4-1-1-1H9a1 1 0 0 0-1 1v1Zm-2 4h12V9c0-.6-.4-1-1-1H7a1 1 0 0 0-1 1v1Zm-1 2a1 1 0 0 0-1 1v6c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1H5Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default CategoriesIcon;
